import { render } from "./BooleanWidget.vue?vue&type=template&id=6ba3eed4"
import script from "./BooleanWidget.vue?vue&type=script&lang=js"
export * from "./BooleanWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__